import { fetchApi } from '@/config/axiosSetting';
import { RemoveDamagedPartsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQuery.type';

export const removeDamagedPartsFunction = (
  params: RemoveDamagedPartsQueryParamsType,
) => {
  const formData = new FormData();
  formData.append('image_id', params.image_id.toString());
  if (params.type === 'initial') {
    return fetchApi.delete(
      `/initial/reports/${params?.id}/images/adjuster/vehicle/damaged_parts/`,
      {
        data: formData,
      },
    );
  }
  if (params.type === 'body') {
    return fetchApi.delete(
      `/body/reports/${params?.id}/images/adjuster/vehicle/damaged_parts/`,
      {
        data: formData,
      },
    );
  }
  return fetchApi.delete(
    `property/reports/${params?.id}/accident_users/${params?.participantRoleType || 'damaged'}/adjuster/vehicle/damaged_parts/`,
    {
      data: formData,
      params: {
        damaged_id: params.damaged_id,
      },
    },
  );
};
